import React, {useEffect, useState} from 'react';
import {functionalitiesAliasMap, strings} from '../../util/strings';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {useHistory} from 'react-router';
import './styles.scss';
import {
  setUser,
  setPurposes,
  setDigitalCommunications,
  setStringsDefault,
  setBusStylesMap,
  setBusFuncMap,
  setBusMap,
  setSelectedBu,
  setAvailableBus,
  addToWizard,
  setStrings,
  setStringsLoaded,
  setGlobalStyles,
  setIsAuthenticated,
  setProducts,
  setCustomerCardModalTrigger,
  setIbanFilterOpenTrigger,
  setBusFuncionalities,
  setBusStyles,
  setBuDefaultFunctionalities,
  setTitular,
  setIban,
  setLanguageOptions,
  setCurrencies,
  setAccessToken,
  setShowPersonalDate,
  setBusGroupExceptions,
  setBusProductExceptions,
  setBusFuncMapDefaultObject,
} from '../../store/actions';
import {
  decodeToken,
  getDateInServerFormat,
  getDaysBetweenDates,
  updateStringFeatureWithLabels,
} from '../../util/utility';
import {get, getWithCustomHeaders, post} from '../../api/api';
import {
  uriCard,
  uriCurrencies,
  uriGetBus,
  uriGetFunctionalities,
  uriGetListConsents,
  uriGetTitular,
  uriGetUserConsents,
  uriUserBu,
  uriUserBuV2,
  uriUserInfo,
} from '../../api/endpoints';
import NewPageLoader from '../../components/page-loader/NewPageLoader';
// import {AppConfigurationClient} from '@azure/app-configuration';
import {Constants} from '../../oauth/helpers/constants';
import getValuesToStoreWithBuDataFromGraphql from '../../graphQL';
import moment from 'moment';
import {getBusExceptions, getBusInfo} from '../../api/client';

interface AuthLoadingPageProps {
  setUser(value: any): void;
  setPurposes(value: any): void;
  stringsDefault: any;
  selectedBu: any;
  setBusStylesMap(value: any): void;
  setBusFuncMap(value: any): void;
  setBusFuncMapDefaultObject(value: any): void;
  setBusMap(value: any): void;
  setSelectedBu(value: any): void;
  setAvailableBus(value: any): void;
  addToWizard(value: any): void;
  setStrings(value: any): void;
  setStringsLoaded(value: any): void;
  setStringsDefault(value: any): void;
  setGlobalStyles(value: any): void;
  setIsAuthenticated(value: any): void;
  setProducts(value: any): void;
  setCustomerCardModalTrigger(value: any): void;
  setIbanFilterOpenTrigger(value: any): void;
  isAuthenticated: any;
  busMap: any;
  setBusFuncionalities(value: any): void;
  setBusStyles(value: any): void;
  setBusProductExceptions(value: any): void;
  setBusGroupExceptions(value: any): void;
  setBuDefaultFunctionalities(value: any): void;
  setTitular(value: any): void;
  setIban(value: any): void;
  setLanguageOptions(value: string[]): void;
  setCurrencies(value: any): void;
  setAccessToken(value: any): void;
  tenant: any;
  setShowPersonalDate(value: boolean): void;
  bankAccountDataHolder: any;
  buDefaultFunctionalities: any;
}

const AuthLoadingPage = ({
  setUser,
  selectedBu,
  stringsDefault,
  setBusStylesMap,
  setBusFuncMap,
  setBusFuncMapDefaultObject,
  setBusMap,
  setSelectedBu,
  setAvailableBus,
  addToWizard,
  setTitular,
  setStrings,
  setStringsLoaded,
  setStringsDefault,
  setGlobalStyles,
  setIsAuthenticated,
  setIban,
  setProducts,
  setCustomerCardModalTrigger,
  setIbanFilterOpenTrigger,
  busMap,
  setBusFuncionalities,
  setBusStyles,
  setBusProductExceptions,
  setBusGroupExceptions,
  setBuDefaultFunctionalities,
  setLanguageOptions,
  setCurrencies,
  setAccessToken,
  tenant,
  setShowPersonalDate,
  bankAccountDataHolder,
  buDefaultFunctionalities,
}: AuthLoadingPageProps) => {
  const history = useHistory();
  // COMMENTED CODE TO FIX BUILD ERROR
  // const appConfigClient = new AppConfigurationClient(
  //   Constants.appConfigEndpoint || ''
  // );
  const urlSearchParams = new URLSearchParams(window.location.search);
  const adminToken: any = urlSearchParams.get('token');
  const isAdmin = !!adminToken;
  const adminAccessToken = atob(adminToken)?.split('&')[0]?.split('=')[1];
  const isApi = atob(adminToken)?.split('&')[4]?.split('=')[1] || 'False';

  const [dataTreatmentReady, setDataTreatmentReady] = useState(false);
  const [skipDataTreatment, setSkipDataTreatment] = useState(true);
  const [consentsReady, setConsentsReady] = useState(false);
  const [showPersonalDateCurrent, setShowPersonalDateCurrent] = useState(false);
  const [personalDateReady, setPersonalDateReady] = useState(false);

  const featureName = 'LoadingHomepage';

  const getLanguageOptions = async () => {
    const languageOptions =
      tenant?.languages?.length > 0 &&
      tenant?.languages?.map((lng: any) => lng.alias);

    setLanguageOptions(languageOptions);
  };

  const getUserFromAuth = () => {
    let userFromAuth: any;

    if (isAdmin) {
      localStorage.setItem('logged_in_by_url', 'true');
      const decodedInfo = decodeToken(adminAccessToken);
      decodedInfo.birthdate = getDateInServerFormat(decodedInfo.birthdate);

      userFromAuth = {...decodedInfo};
      userFromAuth.sub = userFromAuth.sub?.split('/')[1];
    } else {
      localStorage.setItem('logged_in_by_url', 'false');
      userFromAuth = JSON.parse(localStorage.getItem('user') || 'null');
    }

    return userFromAuth;
  };

  const user = getUserFromAuth();

  const hasMobileClaim =
    user?.profile?.mobile &&
    user?.profile?.mobile !== 0 &&
    user?.profile?.mobile !== '';

  const [userProfile, setUserProfile] = useState(user?.profile || user);
  const [stringsToState, setStringsToState] = useState({
    ...strings,
    ...stringsDefault,
  });

  const navigateToNextScreen = (screen: string) => {
    if (
      !hasMobileClaim &&
      tenant?.loginFlow &&
      tenant?.loginFlow.confirmMobile
    ) {
      history.push({
        pathname: '/confirmar-telefone',
        state: {
          screen: screen,
        },
      });
    } else {
      history.push(screen);
    }
  };

  const checkStringsDefault = () => {
    get(uriGetFunctionalities(tenant?.buDefaultAlias || 'ADV'))
      .then((res: any) => {
        let aux = stringsToState;
        aux = updateStringFeatureWithLabels(
          stringsToState,
          res?.data?.items || res,
        );
        setStringsToState({
          ...strings,
          ...aux,
        });
      })

      .catch((err: any) => {
        setStringsDefault(strings);
      });
  };

  const setLocalStorageVariables = () => {
    const now = new Date();
    const expiry_date = new Date(now.getTime() + user.expires_in * 1000);
    const localStorageUser = JSON.parse(
      localStorage?.getItem('user') as string,
    );

    setAccessToken(
      user?.access_token || adminAccessToken || localStorageUser?.access_token,
    );
    localStorage.setItem(
      'access_token',
      user?.access_token || adminAccessToken || localStorageUser?.access_token,
    );
    localStorage.setItem(
      'id_token',
      user?.id_token || localStorageUser?.id_token,
    );
    localStorage.setItem('expires_in', `${user?.expires_in}`);
    localStorage.setItem('expiry_date', `${expiry_date}`);
    localStorage.setItem('show_login_modal', 'true');
    isApi && localStorage.setItem('isApi', isApi);
  };

  const createBusMap = (userBus: any, busObj: any) => {
    const bus = busObj?.data?.items;
    const busMap: any = {};

    // creating a new map with the bus and cards from the response
    userBus.forEach((elem: any) => {
      const famId = elem.famId;
      const buId = elem.buId;
      const existingBu = !!busMap[buId];
      const existingGroup = (busMap[buId] && !!busMap[buId][famId]) || false;

      const member = {...elem};
      const memberBu = bus.find((bu: any) => bu.id === buId);
      member.buName = (memberBu && memberBu.name) || '';

      if (existingBu && existingGroup) {
        busMap[buId][famId].push(member);
      } else if (existingBu && !existingGroup) {
        busMap[buId][famId] = [member];
      } else {
        busMap[buId] = {[`${famId}`]: [member]};
      }
    });

    return busMap;
  };

  const addCardDataToBusMap = async (busMap: any) => {
    // for each card/member of each user's bu obtains the card data and adds it to the busMap
    await Promise.all(
      Object.keys(busMap).flatMap((buId) => {
        return Object.keys(busMap[buId]).map((famId) => {
          return Promise.all(
            busMap[buId][famId].map((member: any, index: number) => {
              return get(
                uriCard(member.buId, member.memId, member.famId),
                false,
                0,
                featureName,
              )
                .then((buUserCard: any) => {
                  busMap[buId][famId][index].card = buUserCard?.data;
                })
                .catch((e: any) => {
                  const buUserIndex = busMap[buId][famId].indexOf(member);

                  // if the card api call fails or returns nothing sets the card as {}
                  busMap[buId][famId][buUserIndex].card = {};
                });
            }),
          );
        });
      }),
    );
  };

  const getTitular = async (newSelectedBu: any) => {
    try {
      let titular: any = await get(
        uriGetTitular(newSelectedBu.buId, newSelectedBu.famId),
        false,
        0,
        featureName,
      );
      if (titular?.data) {
        setTitular(titular?.data);
        setIban(titular.iban);
      } else {
        setTitular({});
        setIban({});
      }
    } catch (err: any) {
      setTitular({});
      setIban({});
    }
  };

  const getBusMap = async (userBus: any, busObj: any) => {
    const busMap = createBusMap(userBus, busObj);
    await addCardDataToBusMap(busMap);

    return busMap;
  };

  const setBusStyleMapToStore = (busMap: any, busStyles: any) => {
    let busStylesMap: any = {};
    if (busMap.length === 0) {
      busStylesMap[0] = busStyles[0];

      setGlobalStyles({
        ...busStylesMap?.[0],
        primaryColor: busStylesMap?.[0]?.primaryColor,
        secondaryColor: busStylesMap?.[0]?.secondaryColor,
        hoverColor: busStylesMap?.[0]?.hoverColor,
        url: busStylesMap?.[0]?.urlLogout,
      });
    } else {
      Object.keys(busMap).forEach(
        (key: string, index: number) => (busStylesMap[key] = busStyles[index]),
      );
      setGlobalStyles({
        ...busStyles?.[0],
        primaryColor: busStyles?.[0]?.primaryColor,
        secondaryColor: busStyles?.[0]?.secondaryColor,
        hoverColor: busStyles?.[0]?.hoverColor,
        url: busStyles?.[0]?.urlLogout,
      });
    }

    setBusStylesMap(busStylesMap);
  };

  const getBusFuncMap = (busMap: any, busFunc: any) => {
    let busFuncMap: any = {};
    if (busMap.length === 0) {
      busFuncMap['NOTCLIENT'] = busFunc[0].funcionalidade;
    } else {
      Object.keys(busMap).forEach((key: string, index: number) => {
        busFuncMap[key] = busFunc[index].funcionalidade;
      });
    }

    return busFuncMap;
  };

  const disableRequests = (busFuncMap: any) => {
    // setting "Pedidos" activa=false if 'Histórico de Reembolso' and 'Pré-autorizações' have activa=false
    Object.keys(busFuncMap).map((key: any) => {
      var reimbursements = busFuncMap[key].find(
        (func: any) =>
          func?.featureTemplateAlias === functionalitiesAliasMap.refund &&
          !func?.isVisible,
      );
      var preauthorizations = busFuncMap[key].find(
        (func: any) =>
          func?.featureTemplateAlias ===
            functionalitiesAliasMap.authorization && !func?.isVisible,
      );
      if (reimbursements && preauthorizations) {
        var pedidos = busFuncMap[key].find(
          (func: any) =>
            func?.featureTemplateAlias === functionalitiesAliasMap.menuRequests,
        );
        pedidos.isVisible = false;
      }
    });
  };

  const setBusFuncMapToStore = (busMap: any, busFunc: any) => {
    const busFuncMap = getBusFuncMap(busMap, busFunc);
    disableRequests(busFuncMap);

    setBusFuncMap(busFuncMap);
  };

  const setSelectedBuToStore = (busMap: any) => {
    var newSelectedBu: any;

    if (busMap.length === 0) {
      newSelectedBu = {
        buId: 'NOTCLIENT',
        name: 'nao-cliente',
        grpId: 0,
        memId: 0,
      };
    } else {
      const auxBus = Object.values(
        Object.values(Object.values(busMap)),
      ).flatMap((group: any) => Object.values(group).flatMap((elem) => elem));

      if (
        localStorage.getItem('BuId') === 'SBS' &&
        auxBus.find((elem: any) => elem.buId === 'SBS')
      ) {
        newSelectedBu = auxBus.find((elem: any) => elem.buId === 'SBS');
      } else {
        const currentProduct = auxBus.find((elem: any) => elem.selectedProduct);

        newSelectedBu =
          currentProduct ||
          auxBus.find((elem: any) => elem.nif === userProfile.nif) ||
          auxBus[0];
      }
      bankAccountDataHolder === 'SUBSCRIBER' && getTitular(newSelectedBu);
    }

    localStorage.setItem('BuId', newSelectedBu?.buId);
    setSelectedBu(newSelectedBu);
  };

  const getBusWithNif = (userBusResponse: any) => {
    let busWithNif: any[] = [];
    Object.keys(userBusResponse).forEach((el: any) => {
      if (userBusResponse[el].nif === userProfile.nif) {
        busWithNif.push(userBusResponse[el]);
      }
    });

    return busWithNif;
  };

  const setListConsents = async (busWithNif: any) => {
    const body: any[] = [];
    let aux: any[] = [];
    let skipDataTreatment = true;
    if (
      busWithNif.length > 0 &&
      stringsDefault?.pt?.login?.login_getListConsents == '1'
    ) {
      busWithNif.forEach((el: any) => {
        body.push({
          buId: el.buId,
          memId: el.memId,
          multicode: el.multicode,
        });
      });
      try {
        await post(
          uriGetListConsents(),
          JSON.stringify(body),
          false,
          featureName,
        ).then((response: any) => {
          response?.data?.items?.forEach((element: any) => {
            aux.push({
              id: element.id,
              response: 'YES',
              sessionId: element.sessionId,
            });
          });
          skipDataTreatment = false;
          addToWizard({
            consentList: aux,
            skipDataTreatment,
          });
        });
      } catch (err: any) {
        skipDataTreatment = true;
        addToWizard({
          skipDataTreatment,
        });
      } finally {
        setSkipDataTreatment(skipDataTreatment);
        setDataTreatmentReady(true);
      }
    } else {
      skipDataTreatment = true;
      addToWizard({
        skipDataTreatment,
      });
      setSkipDataTreatment(true);
      setDataTreatmentReady(true);
    }

    return skipDataTreatment;
  };

  const manageUserConsents = async () => {
    let skipBeforeContinue: boolean = false;
    let updateTerms: boolean = false;
    setConsentsReady(true);
    let skipApiCalls =
      !tenant.loginFlow.beforeContinue && !tenant.loginFlow.dataTreatment;

    !skipApiCalls &&
      (await get(
        uriGetUserConsents(userProfile.nif),
        false,
        0,
        featureName,
      ).then((consents: any) => {
        if (
          consents?.data?.items?.length > 0 &&
          consents?.data?.items[0].purposes.find(
            (purpose: any) =>
              purpose.id ===
                stringsDefault.pt.oneTrust?.purposeTermsAndConditions &&
              purpose.status === 'ACTIVE',
          ) &&
          consents?.data?.items[0].purposes.find(
            (purpose: any) =>
              purpose.id ===
                stringsDefault.pt.oneTrust?.purposePolicyDataTreatment &&
              purpose.status === 'ACTIVE',
          )
        ) {
          skipBeforeContinue = true;
          consents?.data?.items[0].purposes.map((purpose: any) => {
            if (stringsDefault.pt.oneTrust?.versionTermsAndConditions !== '0') {
              if (
                purpose.id ===
                  stringsDefault.pt.oneTrust?.purposeTermsAndConditions &&
                purpose.status === 'ACTIVE' &&
                purpose.version !==
                  parseInt(
                    stringsDefault.pt.oneTrust?.versionTermsAndConditions,
                  )
              )
                updateTerms = true;
            }
          });
        }
      }));
    if (skipBeforeContinue !== undefined) {
      if (
        !skipBeforeContinue &&
        tenant.loginFlow &&
        tenant.loginFlow.beforeContinue
      ) {
        navigateToNextScreen('/politica-marketing'); //before continue
      } else {
        if (updateTerms) navigateToNextScreen('/atualizar-termos');
        else {
          if (
            (userProfile.comunicaçoes_digitais === null ||
              userProfile.comunicaçoes_digitais === undefined) &&
            tenant.loginFlow.insuranceInYourHands
          ) {
            if (userProfile.state === 'CLIENT') {
              navigateToNextScreen('/informacao-seguro');
            } else {
              if (showPersonalDateCurrent) {
                navigateToNextScreen('/confirmar-dados-pessoais');
              } else {
                navigateToNextScreen('/inicio');
              }
            }
          } else {
            navigateToNextScreen('/inicio');
          }
        }
      }
    } else {
      if (showPersonalDateCurrent) {
        navigateToNextScreen('/confirmar-dados-pessoais');
      } else {
        navigateToNextScreen('/inicio');
      }
    }
  };

  const setUserBusSettings = async () => {
    let busResponse: any;
    busResponse = await get(uriGetBus(), false, 0, featureName);

    let userBusResponse: any;
    let busMap: any;
    let busWithNif: any;

    const setUserAndBusForClient = async (resp: any) => {
      setUserProfile({...userProfile, state: 'CLIENT'});
      userBusResponse = resp;
      busMap = await getBusMap(userBusResponse, busResponse);
      busWithNif = getBusWithNif(userBusResponse);
    };

    const setUserAndBusForNotClient = async (err: any) => {
      busMap = [];
      busWithNif = [];
      userBusResponse = busResponse?.data?.items;
      setUserProfile({...userProfile, ...err});
    };

    try {
      if (isAdmin) {
        const headers = {
          Authorization: `Bearer ${adminAccessToken}`,
          isApi: isApi,
        };
        const resp = await getWithCustomHeaders(
          uriUserBu(userProfile.nif, userProfile.birthdate),
          headers,
        );

        await setUserAndBusForClient(resp);
        setProducts(resp);
      } else {
        const resp = (await get(
          uriUserBuV2(userProfile.nif, userProfile.birthdate),
          false,
          0,
          featureName,
        )) as any;

        if (
          resp.data.state === 'NOTCLIENT' ||
          resp.data.state === 'NOT_FOUND'
        ) {
          await setUserAndBusForNotClient(resp.data);
        } else {
          await setUserAndBusForClient(resp?.data?.products);
          setProducts(resp?.data?.products);
        }
      }
    } catch (err: any) {
      await setUserAndBusForNotClient(err);
    } finally {
      setBusMap(busMap);
      setAvailableBus(userBusResponse);
      setSelectedBuToStore(busMap);
      await setListConsents(busWithNif);
    }
  };

  const setCurrenciesMap = async () => {
    await get(uriCurrencies(), false, 0, featureName)
      .then((res: any) => {
        setCurrencies(res?.data?.items);
      })
      .catch();
  };

  const setStoreWithBuDataFromGraphql = async (buId: any) => {
    await getBusInfo(selectedBu.buId === 'NOTCLIENT', busMap, featureName).then(
      (resp) => {
        setBusStyles(resp);
        setBusStyleMapToStore(busMap, resp);
      },
    );

    await getValuesToStoreWithBuDataFromGraphql(
      userProfile,
      selectedBu,
      busMap,
      tenant,
      stringsToState?.pt?.messages?.default_language,
      undefined,
      featureName,
    ).then(
      ({busMap, busFunctionalities, stringsToStore, funcDefaultObject}) => {
        setBusFuncMapToStore(busMap, busFunctionalities);
        setStrings(stringsToStore);
        setStringsLoaded(true);
        setBusFuncionalities(busFunctionalities);
        setBusFuncMapDefaultObject(funcDefaultObject);
      },
    );

    await getBusExceptions('group', busMap, featureName).then((resp) => {
      setBusGroupExceptions(resp);
    });

    await getBusExceptions('product', busMap, featureName).then((resp) => {
      setBusProductExceptions(resp);
    });
  };

  const manageUserPersonalDateDisplay = async (
    personalInfoConfirmationLabels: any,
  ) => {
    const formattedTodayDate = moment(new Date()).format('YYYY-MM-DD');
    let update_personal_date;
    let created;

    await get(uriUserInfo(), false, 0, featureName).then((res: any) => {
      update_personal_date = res?.data?.updatePersonalDate;
      created = res?.data?.createdDate;
    });

    if (!update_personal_date || update_personal_date === null) {
      if (created && created !== null) {
        const daysSinceRegistration = getDaysBetweenDates(
          created,
          formattedTodayDate,
        );
        if (
          daysSinceRegistration >
          parseInt(
            personalInfoConfirmationLabels?.personal_information_days_between_update,
          )
        ) {
          setShowPersonalDate(true);
          setShowPersonalDateCurrent(true);
          navigateToNextScreen('/confirmar-dados-pessoais');
        } else {
          setShowPersonalDate(false);
          setShowPersonalDateCurrent(false);
        }
      } else {
        setShowPersonalDate(true);
        setShowPersonalDateCurrent(true);
        navigateToNextScreen('/confirmar-dados-pessoais');
      }
    } else {
      const daysSinceLastUpdate = getDaysBetweenDates(
        update_personal_date,
        formattedTodayDate,
      );

      if (
        daysSinceLastUpdate >
        parseInt(
          personalInfoConfirmationLabels?.personal_information_days_between_update,
        )
      ) {
        setShowPersonalDate(true);
        setShowPersonalDateCurrent(true);
        navigateToNextScreen('/confirmar-dados-pessoais');
      } else {
        setShowPersonalDate(false);
        setShowPersonalDateCurrent(false);
      }
    }
    setPersonalDateReady(true);
  };

  useEffect(() => {
    // console.log(
    //   'Before oneTrust',
    //   stringsToState,
    //   stringsDefault,
    //   stringsToState?.pt?.oneTrust?.purposeTermsAndConditions,
    //   stringsDefault.pt?.oneTrust?.purposeTermsAndConditions
    // );
    const purpose =
      stringsToState?.pt?.oneTrust?.purposeTermsAndConditions !== ''
        ? stringsToState?.pt?.oneTrust?.purposeTermsAndConditions
        : stringsDefault?.pt?.oneTrust?.purposeTermsAndConditions;
    if (purpose && dataTreatmentReady && !consentsReady && personalDateReady) {
      manageUserConsents();
    }
  }, [dataTreatmentReady, stringsDefault, personalDateReady]);

  useEffect(() => {
    if (selectedBu.buId) {
      setStoreWithBuDataFromGraphql(selectedBu.buId);
    }
  }, [selectedBu.buId]);

  useEffect(() => {
    if (!!userProfile) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
    //if user?.language doesn't exist, set it to default_language
    if (!userProfile?.language) {
      const newUser = {
        ...userProfile,
        language: stringsToState?.pt?.messages?.default_language,
      };
      setUser(newUser);
    } else {
      setUser(userProfile);
    }
  }, [userProfile]);

  useEffect(() => {
    if (tenant) {
      getLanguageOptions();
    }
  }, [tenant?.alias]);

  useEffect(() => {
    setTimeout(() => {
      const personalInfo = buDefaultFunctionalities?.funcionalidade?.find(
        (el: any) =>
          el.featureTemplateAlias ===
          functionalitiesAliasMap.personalInfoConfirmation,
      );
      personalInfo?.isVisible
        ? manageUserPersonalDateDisplay(
            stringsDefault.pt.personalInfoConfirmation,
          )
        : setPersonalDateReady(true);
    }, 1000);
  }, [buDefaultFunctionalities, stringsDefault]);

  useEffect(() => {
    // setStrings(strings);
    !stringsDefault && checkStringsDefault();
    setCustomerCardModalTrigger({showCardModal: false});
    setIbanFilterOpenTrigger({ibanFilter: false});
    setPurposes([]);
    setLocalStorageVariables();
    setDigitalCommunications(userProfile.comunicaçoes_digitais || null);
    setUserBusSettings();
    setCurrenciesMap();
  }, []);

  return (
    <div className="auth-loading-page-container">
      <NewPageLoader />
    </div>
  );
};

const mapStateToProps = ({
  stringsDefault,
  selectedBu,
  busMap,
  tenant,
  bankAccountDataHolder,
  buDefaultFunctionalities,
}: any) => ({
  stringsDefault: stringsDefault.value,
  selectedBu: selectedBu.value,
  busMap: busMap.value,
  tenant: tenant.value,
  bankAccountDataHolder: bankAccountDataHolder.value,
  buDefaultFunctionalities: buDefaultFunctionalities.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setUser: (value: any) => dispatch(setUser(value)),
  setPurposes: (value: any) => dispatch(setPurposes(value)),
  setBusStylesMap: (value: any) => dispatch(setBusStylesMap(value)),
  setBusFuncMap: (value: any) => dispatch(setBusFuncMap(value)),
  setBusMap: (value: any) => dispatch(setBusMap(value)),
  setBusFuncMapDefaultObject: (value: any) =>
    dispatch(setBusFuncMapDefaultObject(value)),
  setSelectedBu: (value: any) => dispatch(setSelectedBu(value)),
  setAvailableBus: (value: any) => dispatch(setAvailableBus(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  setStrings: (value: any) => dispatch(setStrings(value)),
  setStringsLoaded: (value: any) => dispatch(setStringsLoaded(value)),
  setStringsDefault: (value: any) => dispatch(setStringsDefault(value)),
  setGlobalStyles: (value: any) => dispatch(setGlobalStyles(value)),
  setIsAuthenticated: (value: any) => dispatch(setIsAuthenticated(value)),
  setProducts: (value: any) => dispatch(setProducts(value)),
  setDigitalCommunications: (value: any) =>
    dispatch(setDigitalCommunications(value)),
  setCustomerCardModalTrigger: (value: any) =>
    dispatch(setCustomerCardModalTrigger(value)),
  setIbanFilterOpenTrigger: (value: any) =>
    dispatch(setIbanFilterOpenTrigger(value)),
  setBusFuncionalities: (value: any) => dispatch(setBusFuncionalities(value)),
  setBusStyles: (value: any) => dispatch(setBusStyles(value)),
  setBusProductExceptions: (value: any) =>
    dispatch(setBusProductExceptions(value)),
  setBusGroupExceptions: (value: any) => dispatch(setBusGroupExceptions(value)),
  setBuDefaultFunctionalities: (value: any) =>
    dispatch(setBuDefaultFunctionalities(value)),
  setTitular: (value: any) => dispatch(setTitular(value)),
  setIban: (value: any) => dispatch(setIban(value)),
  setLanguageOptions: (value: any) => dispatch(setLanguageOptions(value)),
  setCurrencies: (value: any) => dispatch(setCurrencies(value)),
  setAccessToken: (value: any) => dispatch(setAccessToken(value)),
  setShowPersonalDate: (value: boolean) => dispatch(setShowPersonalDate(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(AuthLoadingPage),
);
